$(document).ready(function() {    

$('#tabs li a:not(:first)').addClass('inactive');
$('.container').hide();
$('.container:first').show();
    
$('#tabs li a').click(function(){
    var t = $(this).attr('id');
  if($(this).hasClass('inactive')){ //this is the start of our condition 
    $('#tabs li a').addClass('inactive');           
    $(this).removeClass('inactive');
    
    $('.container').hide();
    $('#'+ t + 'C').fadeIn('slow');
 }
});
  
  $('.video_open').click(function(){
      $('.iframe_content').addClass('open'); 
      $('header').hide();
  });
  
  $('.iframe_content_video > img').click(function(){
      $('.iframe_content').removeClass('open'); 
      $('header').show();
  });
  
  const $menu = $('.tabs_content iframe');
    $(document).mouseup(e => {
       if (!$menu.is(e.target)) // ... nor a descendant of the container
       {
         $('.iframe_content').removeClass('open'); 
       }
    });

});

jQuery( document ).ready(function() {
    jQuery('.testimonials').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      speed: 800,
    });
});
     $('li.mobile-nav--has-dropdown').click(function(e){
e.preventDefault();
$(this).find('.mobile-nav--dropdown').show();
})